import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AppDashboardPage extends Component {
  render() {
    return (
      <div />
    );
  }
}

AppDashboardPage.propTypes = {};

export default AppDashboardPage;
